module.exports = __webpack_public_path__ + "img/product_5.4424890.webp";